/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notifications_Delete_Confirm_DescriptionInputs */

const he_notifications_delete_confirm_description = /** @type {(inputs: Notifications_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`פעולה זו תבטל את ההתראה עבור מוצר זה`)
};

const en_notifications_delete_confirm_description = /** @type {(inputs: Notifications_Delete_Confirm_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This will remove the notification for this item`)
};

/**
* | output |
* | --- |
* | "This will remove the notification for this item" |
*
* @param {Notifications_Delete_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const notifications_delete_confirm_description = /** @type {((inputs?: Notifications_Delete_Confirm_DescriptionInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notifications_Delete_Confirm_DescriptionInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_notifications_delete_confirm_description(inputs)
	return en_notifications_delete_confirm_description(inputs)
});